import { Component, OnInit, Input } from '@angular/core';
import { StepsError } from '../../errors';
import { Subscription } from 'rxjs/Subscription';
import { StateService } from 'app/state.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
    selector: 'app-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {

    private stepsSubscription: Subscription;
    public dataCheckSuccessful = false;
    private counter = 0;

    constructor(private breadcrumbService: BreadcrumbService, public stateService: StateService) { }

    ngOnInit() {
        this.stateService.stateUpdated$.subscribe(() => {
            this.counter++;
        });
    }

    resultEnabled() {
        return this.stateService.allStepsAreDone() && this.stateService.datacheck;
    }
}



// WEBPACK FOOTER //
// ./src/app/examination/steps/steps.component.ts